import { atom, withInit } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import { debounce } from 'radash'

import { delugeTheme } from '../ui-kit'

import type { DeviceType } from '@blade/ui-kit'
import type { DefaultTheme } from 'styled-components'

const deviceTypeAtom = atom<DeviceType>('mobile', 'deviceTypeAtom').pipe(
  withInit((ctx) => {
    if (typeof window === 'undefined') {
      return 'desktop'
    }

    const handleResize = () =>
      deviceTypeAtom(ctx, matchBreakpoint(window.innerWidth, delugeTheme))

    const debounced = debounce({ delay: 100 }, handleResize)
    window.addEventListener('resize', debounced, { passive: true })

    return matchBreakpoint(window.innerWidth, delugeTheme)
  }),
)

export const useBreakpoint = () => {
  const [device] = useAtom(deviceTypeAtom)

  return device
}

const matchBreakpoint = (width: number, theme: DefaultTheme): DeviceType => {
  if (width >= theme.tablet.width) {
    return 'desktop'
  }
  if (width >= theme.mobile.width) {
    return 'tablet'
  }

  return 'mobile'
}
